export default "__VITE_ASSET__DQDpEV2a__"